import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';
import { Translate } from 'react-localize-redux';

export type VpaFormDecision = 'accepted' | 'rejected' | null;

interface VpaOutcomeChoiceProps {
    outcome: VpaFormDecision;
    onChange: (outcome: VpaFormDecision) => void;
}

/**
 * SHER-759. Optional decision on the bulletin VPA. Nothing is selected until the
 * anaesthetist chooses: a save with no decision must not move the surgical request.
 * The labels are the status labels already shipped for the waiting list.
 */
const VpaOutcomeChoice: React.FC<VpaOutcomeChoiceProps> = ({ outcome, onChange }) => {
    return (
        <FormControl component="fieldset" sx={{ mb: 2 }}>
            <FormLabel component="legend">
                <Translate id="hospital.vpa-form-outcome.legend" />
            </FormLabel>
            <RadioGroup
                value={outcome ?? ''}
                onChange={(event) => {
                    const value = event.target.value;
                    onChange(value === 'accepted' || value === 'rejected' ? value : null);
                }}
            >
                <FormControlLabel
                    value=""
                    control={<Radio inputProps={{ 'data-testid': 'vpa-outcome-none' } as any} />}
                    label={<Translate id="hospital.vpa-form-outcome.none" />}
                />
                <FormControlLabel
                    value="accepted"
                    control={<Radio inputProps={{ 'data-testid': 'vpa-outcome-accepted' } as any} />}
                    label={<Translate id="pages.hospital.services.request_status.ANESTHESIOLOGIST_ACCEPTED" />}
                />
                <FormControlLabel
                    value="rejected"
                    control={<Radio inputProps={{ 'data-testid': 'vpa-outcome-rejected' } as any} />}
                    label={<Translate id="pages.hospital.services.request_status.ANESTHESIOLOGIST_REJECTED" />}
                />
            </RadioGroup>
        </FormControl>
    );
};

export default VpaOutcomeChoice;
